import {
  DATA_TO_ADD,
  FETCH_FARS_DATA,
  STORE_DATA_TO_EDIT,
  DATA_TO_BE_DELETED,
  FATALITY_REPORTS,
  REPORT_TO_REMOVE,
  REMOVE_FROM_QUEUE,
  GET_FORM_IO_FORM_ID,
} from './actions';
import { IReport, IFarsQueueItem } from '../../../../common/sharedTypes';

interface farsState {
  farsData: IFarsQueueItem[];
  farsDataToAdd: any[];
  farsDataToEdit: any[];
  farsDataToDelete: any[];
  reportsWithFatalities: IReport[];
  farsFormIoFormId: string;
}

const initialState: farsState = {
  farsData: [],
  farsDataToAdd: [],
  farsDataToEdit: [],
  farsDataToDelete: [],
  reportsWithFatalities: [],
  farsFormIoFormId: '',
};

const farsReducer = (state = initialState, action) => {
  let _state = { ...state };
  switch (action.type) {
    case DATA_TO_ADD:
      _state.farsData = action.value;
      return _state;
    case FETCH_FARS_DATA:
      _state.farsData = action.value;
      return _state;
    case STORE_DATA_TO_EDIT:
      _state.farsData = state.farsData.map((x) =>
        x.farsCrashData.id == action.value.farsQueueItem.farsCrashData.id
          ? action.value.farsQueueItem
          : x
      );
      if (
        !_state.farsData.some(
          (x) =>
            x.farsCrashData.id == action.value.farsQueueItem.farsCrashData.id
        )
      ) {
        _state.farsData = [..._state.farsData, action.value.farsQueueItem];
      }
      if (action.value.report && action.value.report.id) {
        _state.reportsWithFatalities = state.reportsWithFatalities.map((x) =>
          x.id == action.value.report.id ? action.value.report : x
        );
      }
      return _state;
    case REPORT_TO_REMOVE:
      _state.reportsWithFatalities = state.reportsWithFatalities.filter(
        (x) => x.id != action.value
      );
      return _state;
    case DATA_TO_BE_DELETED:
      _state.farsDataToDelete = action.value;
      return _state;
    case FATALITY_REPORTS:
      _state.reportsWithFatalities = action.value;
      return _state;
    case REMOVE_FROM_QUEUE:
      _state.farsData = state.farsData.filter(
        (x) => x.farsCrashData.id != action.value
      );
      return _state;
    case GET_FORM_IO_FORM_ID:
      _state.farsFormIoFormId = action.value;
      return _state;
    default:
      return state;
  }
};

export default farsReducer;
